import React from 'react';
import Picture from './Picture';

const CloudFrontPicture = ({
    src, webp, gif, altText, png, schnoffle, path = 'images', noQuery,
}) => {
    const queryString = noQuery ? '' : '?x-schnoffle-request=gallery';
    const base = schnoffle ?
        `https://d1hifgxwzqc0jz.cloudfront.net/${path}/` :
        `https://dd2k02hhj0n6fcf.cloudfront.net/${path}/`;
    const webpSource = webp ? base + webp + queryString : null;
    const imgSource = src ? base + src + queryString : null;
    const gifSource = gif ? base + gif + queryString : null;

    return (
        <Picture
            webp={webpSource} gif={gifSource} src={imgSource} alt={altText}
            png={png}
        />
    );
};

export default CloudFrontPicture;



// WEBPACK FOOTER //
// ./src/components/image/CloudFrontPicture.js